import ImageWithEmptyFallback from "src/components/ImageWithEmptyFallback/ImageWithEmptyFallback";
import { useTopupDetails } from "../../context/TopupDetailsContext";
import RequiredFields from "../RequiredFields/RequiredFields";
import Config from "src/app.config";

export default function TopupMain() {
  const { item, isFetching } = useTopupDetails();
  const requiredFields = item?.requiredFields;
  const imgUrl = item?.imageUrl;


  return (
    <div className="flex flex-col justify-center divide-border-default divide-y p-4 gap-4">
      <div className="border-border-default flex items-center gap-4 p-4">
        <div className="outline-border-default aspect-square max-h-14 rounded-md bg-background-default p-1 outline">
          <ImageWithEmptyFallback className="aspect-square rounded-sm" src={`${Config.GCP_IMAGES_BUCKET}${imgUrl}`}/>
        </div>
        <div className="flex flex-col items-start">
          <div className="text-lg">{item?.brand}</div>
          <div className="text-font-subtle text-xs">{item?.name}</div>
        </div>
      </div>
      <div className="p-4">
        <RequiredFields requiredFields={requiredFields} isFetching={isFetching} />
      </div>
    </div>
  );
}
